import Tooltip from "@mui/material/Tooltip";
import { useRouter } from "next/navigation";
import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";
import { xssFilter } from "@/utils/xss";

import { QuestionType } from "../services/get-session-list-data";
import { QuestionItemMenu } from "./QuestionItemMenu";

type Props = {
  id: string;
  questionType: QuestionType;
  title: string;
  date: string;
  isActive?: boolean;
} & ComponentProps<"div">;

export const QuestionItem = ({
  id,
  questionType,
  title,
  date,
  isActive,
  ...props
}: Props) => {
  const router = useRouter();

  return (
    <div
      {...props}
      onClick={(event) => {
        router.push(links.myWinwingptQuestion({ id: id.toString() }));
        props.onClick?.(event);
      }}
      className={twMerge(
        "relative flex cursor-pointer flex-col gap-y-2 py-4 pl-2 hover:bg-sky-50 @3xl:py-1.5 @3xl:pl-3.5",
        isActive ? "bg-sky-50" : "bg-white",
        props.className
      )}
    >
      <div className="flex items-center justify-between">
        <Tooltip
          enterDelay={1000}
          arrow={true}
          title={title}
          placement="top"
          className="z-50"
          slotProps={{
            tooltip: { className: "bg-zinc-500 text-white" },
            arrow: { className: "text-zinc-500" },
          }}
        >
          <p className="truncate text-sm">{xssFilter(title)}</p>
        </Tooltip>
        <QuestionItemMenu id={id} />
      </div>
      <div className="flex items-center gap-2">
        <QuestionTypeBadge type={questionType} />
        <p className="text-sm text-zinc-500">{date}</p>
      </div>
    </div>
  );
};

const badgeColors = {
  default: "bg-zinc-100 border-zinc-200 text-zinc-500",
  nonDefault: "bg-green-100 border-green-200 text-green-500",
  error: "bg-red-100 border-red-200 text-red-500",
};

const QuestionTypeBadge = ({ type }: { type: QuestionType }) => {
  const { t } = useLang();

  return (
    <span
      className={`rounded-full border px-1.5 text-[10px] ${badgeColors[type]}`}
    >
      {t.winwingpt.questionType[type]}
    </span>
  );
};
